import { Suspense, lazy } from "react";
import { Helmet } from "react-helmet-async";

import SuspenseLoader from "src/components/SuspenseLoader";

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const Customers = Loader(lazy(() => import("src/content/customers")));

const customerRoutes = [
  {
    path: "/",
    element: (
      <>
        <Helmet>
          <title> Müşteriler </title>
        </Helmet>
        <Customers />
      </>
    ),
  },
];

export default customerRoutes;
